// extracted by mini-css-extract-plugin
export default {"content":"_VPAQ83_NVbbKcmA02CT","badge":"vr29ZB5A3ne61b7BLuI4","common_bganimation":"fQvCQd1fmmgvbjKGomEG"};